export const ACCOUNT_HISTORY_EVENTS = [
    "created",
    "updated",
    "activated",
    "deactivated",
    "archived",
    "restored",
];
export const ACCOUNT_HISTORY_EVENT_LABELS = {
    created: "Счёт создан",
    updated: "Реквизиты изменены",
    activated: "Сделан активным",
    deactivated: "Снят с активного",
    archived: "Архивирован",
    restored: "Восстановлен из архива",
};
export function formatIban(value) {
    return value
        .replace(/\s+/g, "")
        .toUpperCase()
        .replace(/(.{4})/g, "$1 ")
        .trim();
}
const GE_IBAN_RE = /^GE\d{2}[A-Z]{2}\d{16}$/;
export function validateGeIban(value) {
    const v = value.replace(/\s+/g, "").toUpperCase();
    if (!v.startsWith("GE")) {
        if (v.length < 15 || v.length > 34)
            return { ok: false, reason: "invalid_length" };
        return { ok: true };
    }
    if (!GE_IBAN_RE.test(v))
        return { ok: false, reason: "invalid_ge_format" };
    const rearranged = v.slice(4) + v.slice(0, 4);
    let remainder = 0;
    for (const char of rearranged) {
        const code = char >= "A" && char <= "Z" ? String(char.charCodeAt(0) - 55) : char;
        for (const digit of code) {
            remainder = (remainder * 10 + Number(digit)) % 97;
        }
    }
    if (remainder !== 1)
        return { ok: false, reason: "invalid_checksum" };
    return { ok: true };
}
//# sourceMappingURL=index.js.map